import React from "react";

const HTMLIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="20" height="20"
         viewBox="0 0 20 20">
        <defs>
            <path id="za62a"
                  d="M408 1136c0 .266-.105.52-.293.707l-.293.293.293.293a.996.996 0 0 1 .293.707v4a1 1 0 0 0 1 1 1 1 0 1 1 0 2c-1.654 0-3-1.346-3-3v-3.586l-.707-.707a.999.999 0 0 1 0-1.414l.707-.707V1132c0-1.654 1.346-3 3-3a1 1 0 1 1 0 2 1 1 0 0 0-1 1v4m16.707.293a.999.999 0 0 1 0 1.414l-.707.707V1142c0 1.654-1.346 3-3 3a1 1 0 1 1 0-2 1 1 0 0 0 1-1v-4c0-.266.105-.52.293-.707l.293-.293-.293-.293A.996.996 0 0 1 422 1136v-4a1 1 0 0 0-1-1 1 1 0 1 1 0-2c1.654 0 3 1.346 3 3v3.586l.707.707m-7.336-5.222a1 1 0 0 1 .558 1.3l-4 10a1.002 1.002 0 0 1-1.3.557 1 1 0 0 1-.558-1.299l4-10a.999.999 0 0 1 1.3-.558"/>
            <clipPath id="za62b">
                <use xlinkHref="#za62a"/>
            </clipPath>
        </defs>
        <g>
            <g transform="translate(-405 -1127)">
                <g>
                    <use fill="#31373d" xlinkHref="#za62a"/>
                </g>
                <g clipPath="url(#za62b)">
                    <g>
                        <path fill="#919eab" d="M1127 405h21v21h-21z"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default HTMLIcon;
